module.exports = __webpack_public_path__ + "img/list-grid-view.f91f1825.svg";